import { Component, OnInit } from '@angular/core';
import { ApplicationService } from '../../../services/application.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { NgIf, NgFor } from '@angular/common';
import { TemplateService } from '../../../services/template.service';
import { drill } from '../../../models/drill';
import { CreateDrillComponent } from '../create-drill/create-drill.component';

@Component({
  selector: 'app-drills-list',
  standalone: true,
  imports: [NgIf, NgFor, CreateDrillComponent],
  templateUrl: './drills-list.component.html',
  styleUrl: './drills-list.component.css'
})
export class DrillsListComponent implements OnInit {
  constructor(private applicationService:ApplicationService, private authenticationService:AuthenticationService, private templateService:TemplateService) {
    
  }

  drills:Array<drill> = [];
  showComponent: 'LIST' | 'CREATE' = "LIST";

  ngOnInit(): void {
    this.searchDrills();
  }

  async searchDrills() {
    let username = this.authenticationService.loggedInUser?.username;
    if(!username) return;
    this.applicationService.showGlobalSpinner();
    this.drills = await this.templateService.searchDrills(username);
    this.applicationService.hideGlobalSpinner();
  }
}
